document.querySelectorAll('[data-catalogue]').forEach(catalogue => {
  const filters = catalogue.querySelector('[data-filters]');
  const grid = catalogue.querySelector('[data-grid]');
  if (!filters || !grid) return;
  const cards = [...grid.querySelectorAll('[data-gift]')];
  const search = catalogue.querySelector('[data-search]');
  const sort = catalogue.querySelector('[data-sort]');
  const resultCount = catalogue.querySelector('[data-results]');
  const more = catalogue.querySelector('[data-more]');
  const empty = catalogue.querySelector('[data-empty]');
  const batchSize = 9;
  let limit = batchSize;

  function update() {
    const category = filters.querySelector('input[name=category]:checked').value;
    const words = search.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
    const matches = cards.filter(card =>
      (category === 'All gifts' || card.dataset.category === category) &&
      words.every(word => card.dataset.searchable.includes(word)));
    if (sort.value === 'number') matches.sort((a, b) => Number(a.dataset.number) - Number(b.dataset.number));
    if (sort.value === 'price-low' || sort.value === 'price-high') {
      const direction = sort.value === 'price-low' ? 1 : -1;
      matches.sort((a, b) => {
        if (!a.dataset.price || !b.dataset.price) return Number(!a.dataset.price) - Number(!b.dataset.price);
        return direction * (Number(a.dataset.price) - Number(b.dataset.price));
      });
    }
    const visible = matches.slice(0, limit);
    cards.forEach(card => { card.hidden = true; });
    visible.forEach(card => { card.hidden = false; grid.append(card); });
    empty.hidden = matches.length > 0;
    more.hidden = visible.length >= matches.length;
    if (visible.length < matches.length) {
      resultCount.textContent = 'Showing ' + visible.length + ' of ' + matches.length + ' gifts';
    } else {
      resultCount.textContent = matches.length + (matches.length === 1 ? ' gift' : ' gifts');
    }
    return visible;
  }

  function reset() {
    limit = batchSize;
    update();
  }
  filters.addEventListener('change', reset);
  search.addEventListener('input', reset);
  more.addEventListener('click', () => {
    const previous = limit;
    limit += batchSize;
    update()[previous]?.querySelector('.card-title a')?.focus();
  });
  filters.hidden = false;
  update();
});

document.querySelectorAll('[data-gift-form]').forEach(form => {
  const options = form.querySelectorAll('input[type=radio]:enabled');
  if (options.length === 1) options[0].checked = true;
});
